import { Grid } from '@mui/material';
import React from 'react';
import DocumentationLayout from '../../layout/dashboard/DocumentationLayout';
import DocumentationContent from '../../components/documentation.js/DocumentationContent';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';

const DocumentationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { view, searchValue } = queryString.parse(location.search);

  const handleNavigate = (sectionKey) => {
    const params = new URLSearchParams();
    params.set('view', sectionKey);
    if (searchValue) {
      params.set('searchValue', searchValue);
    }
    navigate(`/documentation?${params.toString()}`);
  };

  const handleSearch = (query) => {
    const params = new URLSearchParams();
    if (query) {
      params.set('searchValue', query);
    } else if (view) {
      params.set('view', view);
    }
    navigate(`/documentation?${params.toString()}`);
  };

  const handleBack = () => {
    const params = new URLSearchParams();
    if (searchValue) {
      params.set('searchValue', searchValue);
    }
    navigate(`/documentation?${params.toString()}`);
  };
  const handleSidebarNavigate = (sectionKey) => {
    navigate(`/documentation?view=${sectionKey}`);
  };

  return (
    <DocumentationLayout onSidebarNavigate={handleSidebarNavigate}>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <DocumentationContent
            selectedSection={view || 'about'}
            onNavigate={handleNavigate}
            onSearch={handleSearch}
            onBack={handleBack}
            searchValue={searchValue || ''}
          />
        </Grid>
      </Grid>
    </DocumentationLayout>
  );
};

export default DocumentationPage;
